export const getActionName = ({ type, id = null }) => {
  return `${id ? `${id}::` : ''}${type}`;
};

export default {
  getActionName,
};
